var _rect, _rect2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackupAva(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#1C63D5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3034_26707",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 20,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3034_26707)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4167 26.6667C14.1528 26.6667 13.0731 26.2292 12.1775 25.3542C11.2814 24.4792 10.8334 23.4097 10.8334 22.1458C10.8334 21.0625 11.1598 20.0972 11.8125 19.25C12.4653 18.4028 13.3195 17.8611 14.375 17.625C14.7223 16.3472 15.4167 15.3125 16.4584 14.5208C17.5 13.7292 18.6806 13.3333 20 13.3333C21.625 13.3333 23.0034 13.8992 24.135 15.0308C25.2673 16.1631 25.8334 17.5417 25.8334 19.1667C26.7917 19.2778 27.587 19.6908 28.2192 20.4058C28.8509 21.1214 29.1667 21.9583 29.1667 22.9167C29.1667 23.9583 28.8023 24.8439 28.0734 25.5733C27.3439 26.3022 26.4584 26.6667 25.4167 26.6667H20.8334C20.375 26.6667 19.9828 26.5036 19.6567 26.1775C19.33 25.8508 19.1667 25.4583 19.1667 25V20.7083L17.8334 22L16.6667 20.8333L20 17.5L23.3334 20.8333L22.1667 22L20.8334 20.7083V25H25.4167C26 25 26.4931 24.7986 26.8959 24.3958C27.2987 23.9931 27.5 23.5 27.5 22.9167C27.5 22.3333 27.2987 21.8403 26.8959 21.4375C26.4931 21.0347 26 20.8333 25.4167 20.8333H24.1667V19.1667C24.1667 18.0139 23.7606 17.0311 22.9484 16.2183C22.1356 15.4061 21.1528 15 20 15C18.8473 15 17.8648 15.4061 17.0525 16.2183C16.2398 17.0311 15.8334 18.0139 15.8334 19.1667H15.4167C14.6112 19.1667 13.9237 19.4514 13.3542 20.0208C12.7848 20.5903 12.5 21.2778 12.5 22.0833C12.5 22.8889 12.7848 23.5764 13.3542 24.1458C13.9237 24.7153 14.6112 25 15.4167 25H17.5V26.6667H15.4167Z",
    fill: "#F2F4F6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackupAva);
export default __webpack_public_path__ + "static/media/BackupAva.d60b83db1f57dd5332185b7324fbee0f.svg";
export { ForwardRef as ReactComponent };